import { useMutation, useQuery } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React from "react";
import { GET_TIKTOK_PRODUCT_TEMPLATE_ACCESS_LEVEL } from "../../../graphql/queries";
import TeamMemberSelect from "../../team-member/components/team-member-select";
import { TEAM_ROLE } from "../../../variable";
import { handleError, reducerFn } from "../../../helper";
import { GRANT_ACCESS_TIKTOK_PRODUCT_TEMPLATE } from "../../../graphql/mutations";
import { useToastContext } from "../../shared/ToastContext";
import { get } from "lodash";
import { useProductTemplateAccessLevel } from "./product-template-access-level-ctx";

export default function ProductTemplateAccessLevel({
  open,
  onClose,
  template,
}) {
  const [state, setState] = React.useReducer(reducerFn, {
    userIds: [],
  });

  const { setNotify, toggleToast } = useToastContext();
  const { refetch } = useProductTemplateAccessLevel() || {};

  const { data } = useQuery(GET_TIKTOK_PRODUCT_TEMPLATE_ACCESS_LEVEL, {
    variables: {
      id: template?.id,
    },
    skip: !template || !template.id || !open,
  });

  const [grantAccess, { loading: loadingGrant }] = useMutation(
    GRANT_ACCESS_TIKTOK_PRODUCT_TEMPLATE,
    {
      onCompleted: () => {
        onClose && onClose();
        setNotify({
          msg: "Grant access this template for user success",
          err: false,
        });

        refetch && refetch();
      },
      onError: (err) => {
        setNotify({ msg: handleError(err?.toString()), err: true });
      },
    },
  );

  const handleSubmit = React.useCallback(() => {
    if (!template.id) return;

    toggleToast && toggleToast(true);
    setNotify && setNotify({ msg: null, err: false });

    grantAccess({
      variables: {
        ids: [template.id],
        userIds: state.userIds,
      },
    });
  }, [grantAccess, toggleToast, setNotify, state.userIds, template.id]);

  const handleValuesChange = React.useCallback((val) => {
    setState({ userIds: val });
  }, []);

  React.useEffect(() => {
    if (!data) return;

    const userIds = getUserIds(data);
    setState({ userIds });
  }, [data]);

  React.useEffect(
    () => () => {
      setState({ userIds: [] });
    },
    [],
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      sectioned
      large
      title="Share product template"
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loadingGrant,
      }}
      secondaryActions={[{ content: "Cancel", onAction: onClose }]}
    >
      <TeamMemberSelect
        label="Users"
        allowMultiple
        value={state.userIds}
        onChange={handleValuesChange}
        getValueImmediate
        filter={{
          roles: [
            TEAM_ROLE.Admin,
            TEAM_ROLE.MarketplaceManager,
            TEAM_ROLE.StoreManager,
          ],
        }}
      />
    </Modal>
  );
}

function getUserIds(data) {
  const nodes = get(data, "getTiktokProductTemplateAccessLevel") || [];
  const res = [];
  for (let node of nodes) {
    if (!node || !node.userID) {
      continue;
    }
    res.push(node.userID);
  }

  return res;
}
